export const sanitize = (o) => Object.keys(o).reduce((l, k) => {
    if (typeof l[k] === 'object') sanitize(l[k]);
    else if (l[k] === undefined) delete l[k];
    return l;
}, o);

export const reset = () => window?.dataLayer.push({ ecommerce: null });
